export enum ETabEvent {
    OPEN = 'tab:open',
    ACTIVATED = 'tab:activated'
}
